
export const openPresentation = (navigate, id) =>{
  navigate(`/presentations/${id}/key-messages`);
};
